export default __webpack_public_path__ + "static/ucc-7460ec69ecb45a1a49f15bc1e1a4757d.png";